import { round } from 'lodash';

/**
 * Safely rounds a numeric value to a specified number of decimal places.
 * Returns null if the input value is null or undefined.
 *
 * @param value - The number to round, can be number, null, or undefined
 * @param roundDigits - The number of decimal places to round to
 * @returns The rounded number or null if input was null/undefined
 */
export const roundSafe = (
  value: number | null | undefined,
  roundDigits: number
): number | null =>
  typeof value === 'number' ? round(value, roundDigits) : null;
